import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 5850EAB7-9808-4FC7-B107-ECBC0D74321A
 * name clock-time-four
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-time-four.svg
 * tags
 * - Date / Time 
 */
export const ClockTimeFourIcon = createSvgIcon(<><path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M16.3 15.2L11 12.3V7H12.5V11.4L17 13.9L16.3 15.2Z" /></>, 'ClockTimeFourIcon');
export default ClockTimeFourIcon